/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable prettier/prettier */
import * as React from 'react';
import { useIntl } from 'react-intl';
import { IHeadProps } from '../TableHead';

interface IComponentProps {
  label: boolean;
  action?: (title: string, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  stateStartMin: number | string;
  stateStartMax: number | string;
  stateMin: number | string;
  stateMax: number | string;
  setStateValue: (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    key: string,
    val: string | number,
    name: string,
    columnId: string
  ) => void;
  menuNameOpen: {
    [key: string]: boolean
  };
}

type Props = IHeadProps & IComponentProps;
const FilteredMultipleSelect: React.FC<Props> = ({ ...props }) => {
  const { formatMessage: f } = useIntl();

  const actionOpen = (e: any) =>  {
    props.actionOpen(e, props.columns?.name || '');
  }

  const actionSave = (e: any) => {
    const { columns, stateValue, filterComponent } = props;
    if (filterComponent) {
      props.actionSave(columns?.name || '', stateValue, e, filterComponent.type, columns?.title || '');
    }
  }

  const action = (e: any) => {
    if (props.action) {
      props.action(props.columns?.name || '', e);
    }
  }

  const { columns, filterComponent } = props;
  return (
    <div
      data-cy={`multiple-select-popup-${columns?.name}`}
      className={`label ${props.label ? 'label-primary mb-xs position-relative' : ''}
        ${props.menuNameOpen[props.columns?.name || ''] === props.label ? 'open' : ''}`}
      style={{ padding: !props.label ? '0px' : '7px 16px' }}
    >
     
      {props.label && filterComponent && (
        <span onClick={actionOpen}>
          <a
            href="#"
            title={f({ id: 'table.filter.button' })}
            data-cy="multiple-select-open-filter"
            className="dropdown-toggle text-white text-decoration-none"
            id="dropdownMenu13"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            {columns?.title}: {filterComponent.selectedValue}
          </a>
          <a
            href="#"
            title={f({ id: 'table.filter.remove' })}
            data-cy="multiple-select-remove"
            className="text-white"
            onClick={action}
            style={{ padding: '8px', margin: '-8px -8px -8px 0' }}
          >
            <i className="cmd-icon cmd-icon-remove-sm" />
          </a>
        </span>
      )}
      <div
        className="dropdown-menu dropdown-menu-custom fs-2 js-dropdown-keep-open"
        aria-labelledby="dropdownMenu10"
      >
        {filterComponent && filterComponent.values && Array.isArray(filterComponent.values)
          ? filterComponent.values.map((i: any, index: any) => (
            <div
              key={index}
              className={`e-checkbox px-2 py-1 d-block text-black  font-weight-normal ${
                  index % 2 !== 0 ? 'bg-gray-light' : ''
                }`}
            >
              <label>
                <input type="checkbox" data-cy={`multiple-select-checkbox-${columns?.name}`} />
                <span className="pl-5">{i}</span>
              </label>
            </div>
            ))
          : ''}
        <div className="row m-0 px-1 py-1 pt-2">
          <div className="col-6 px-xs">
            <a
              href="#"
              title={f({ id: 'table.filter.reset' })}
              data-cy="multiple-select-button-reset"
              id="reset"
              className="e-button d-flex"
            >
              Reset
            </a>
          </div>
          <div className="col-6 px-xs">
            <a
              href="#"
              title={f({ id: 'table.apply' })}
              data-cy="multiple-select-button-apply"
              className="e-button e-button--gray d-flex"
              onClick={actionSave}
            >
              {f({ id: 'table.apply' })}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilteredMultipleSelect;
